// @flow

export const stripUrlQuery = (url: string = ''): string => {
  try {
    const parsed = new URL(url)
    parsed.search = ''
    parsed.hash = ''

    return parsed.toString()
  } catch (err) {
    const queryIndex = url.indexOf('?')

    return queryIndex === -1 ? url : url.slice(0, queryIndex)
  }
}

export default stripUrlQuery
